<template>
  <div class="label-left">
    <div class="label-ctrl-group">
      <div class="label-ctrl-label">
        <div class="label-item">{{ date | formatDate('YYYY年') }}</div>
        <div class="label-item">{{ date | formatDate('MM月DD日') }}</div>
      </div>

      <el-popover
        trigger="click"
        placement="right-start"
        popper-class="padding-none"
      >
        <date-picker
          v-loading="loading"
          :date="date"
          :date-count="dateCount"
          @change="dayChange"
          @pre-change="monthChange"
        ></date-picker>

        <div slot="reference" class="label-ctrl-button">
          <i class="el-icon-search"></i>
          <div>查询</div>
        </div>
      </el-popover>

      <div
        class="label-ctrl-button"
        :class="{ disabled: prev < 0 }"
        @click="go(prev)"
      >
        <i class="el-icon-caret-left"></i>
        <div>上一张</div>
      </div>

      <div
        class="label-ctrl-button"
        :class="{ disabled: next < 0 }"
        @click="go(next)"
      >
        <i class="el-icon-caret-right"></i>
        <div>下一张</div>
      </div>
    </div>

    <div class="label-ctrl-group text-group-edit" @click="emitAction('create')">
      <el-tooltip
        class="item"
        effect="dark"
        content="按住 左Shift 连续添加"
        placement="right"
      >
        <div
          class="label-ctrl-button"
          :class="{ actived: creating }"
          @click="addLabel"
        >
          <i class="el-icon-edit-outline"></i>
          <div>添加标注</div>
        </div>
      </el-tooltip>

      <!-- <div
        class="label-ctrl-button"
        :class="{ disabled: !(active > -1) }"
        @click="copy"
      >
        <i class="el-icon-copy-document"></i>
        <div>复制</div>
      </div> -->

      <div
        class="label-ctrl-button"
        :class="{ disabled: !(active > -1) }"
        @click="remove"
      >
        <i class="el-icon-document-remove"></i>
        <div>删除</div>
      </div>
    </div>

    <div class="label-ctrl-group text-group-save">
      <div
        class="label-ctrl-button"
        :class="{ disabled: !edited }"
        @click="save"
      >
        <i class="el-icon-document-checked"></i>
        <div>保存</div>
      </div>
    </div>

    <div class="label-ctrl-group">
      <div class="label-ctrl-text">
        <div>{{ Math.ceil(scale) }}%</div>
      </div>

      <!-- <div class="label-ctrl-button" @click="zoomIn">
        <i class="el-icon-circle-plus-outline"></i>
        <div>放大</div>
      </div>

      <div class="label-ctrl-button" @click="zoomOut">
        <i class="el-icon-remove-outline"></i>
        <div>缩小</div>
      </div> -->

      <div class="label-ctrl-button" @click="fitWindow">
        <i class="el-icon-rank"></i>
        <div>适应窗口</div>
      </div>
    </div>

    <div class="label-ctrl-group text-group-edit">
      <div class="label-ctrl-button" @click="downloadTxt">
        <i class="el-icon-download"></i>
        <div>下载TXT</div>
      </div>

      <div class="label-ctrl-button" @click="downloadOrig">
        <i class="el-icon-picture-outline"></i>
        <div>下载原图</div>
      </div>
    </div>

    <div class="label-ctrl-group text-group-manager">
      <div class="label-ctrl-button" @click="tiggleUploader">
        <i class="el-icon-upload2"></i>
        <div>上传图片</div>
      </div>
    </div>

    <div v-if="isAdmin" class="label-ctrl-group text-group-manager">
      <div class="label-ctrl-button" v-loading="recognizing" @click="recognize">
        <svg-icon icon-class="bug"/>
        <div>识别</div>
      </div>
    </div>

    <!-- <div class="label-ctrl-group">
      <div class="label-ctrl-button" @click="emitAction('full-screen')">
        <i class="el-icon-full-screen"></i>
        <div>全屏</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'

export default {
  components: { DatePicker },
  props: {
    prev: Number,
    next: Number,
    scale: Number,
    minScale: Number,
    active: Number,
    date: String,
    dateCount: Array,
    creating: Boolean,
    loading: Boolean,
    edited: Boolean,
    recognizing: Boolean
  },
  computed: {
    isAdmin() {
      return this.role && this.role.id === 1
    }
  },
  methods: {
    go(idx) {
      if (idx < 0) return
      this.$emit('go', idx)
    },
    emitAction(action) {
      this.$emit(action)
    },
    zoomIn() {
      this.$emit('zoom', this.scale + 20)
    },
    zoomOut() {
      this.$emit('zoom', Math.max(this.minScale, this.scale - 20))
    },
    fitWindow() {
      this.$emit('fit-window')
    },
    dayChange(date) {
      this.$emit('day-change', date)
    },
    monthChange(m) {
      this.$emit('month-change', m)
    },
    addLabel() {
      this.$emit('add-label')
    },
    remove() {
      this.$emit('remove', this.active)
    },
    copy() {
      this.$emit('copy', this.active)
    },
    save() {
      this.$emit('save')
    },
    downloadTxt() {
      this.$emit('download-txt')
    },
    downloadOrig() {
      this.$emit('download')
    },
    tiggleUploader() {
      this.$emit('triggle-uploader')
    },
    recognize() {
      if (!this.recognizing) {
        this.$emit('recognize')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-left {
  height: 100%;
  width: 72px;
  background: #f1f1f1;
  color: #606266;
  user-select: none;
  font-size: 14px;
  .text-group-edit {
    color: #e6a23c;
  }
  .text-group-save {
    color: #67c23a;
  }
  .text-group-manager {
    color: #409eff;
  }
  overflow: auto;
}
.label-ctrl-group {
  width: 100%;
}
.label-ctrl-group:not(:last-child) {
  border-bottom: 1px dashed #c1c1c1;
}
.label-ctrl-label {
  height: 66px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .label-item {
    padding-bottom: 8px;
  }
}
.label-ctrl-button {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  i, svg {
    font-size: 1.5rem;
    margin-bottom: 8px;
  }
  div {
    user-select: none;
  }
  &:hover {
    color: #409eff;
    box-shadow: 1px 1px 2px #888888, 0 -1px 5px #888888;
  }
}
.label-ctrl-button.disabled {
  color: #d1d1d1;
  cursor: no-drop;
  box-shadow: none;
}
.label-ctrl-button.actived {
  color: #c6821c;
  box-shadow: 1px 1px 2px #888888 inset, 0 -1px 4px #888888 inset;
}
.label-ctrl-text {
  text-align: center;
  margin-top: 4px;
  padding: 4px;
  background-color: #fff;
}
</style>
